import {Component} from '@angular/core';

@Component({
    selector: 'eocm-warning-bar',
    templateUrl: './warning-bar.component.html',
    styleUrls: ['./warning-bar.component.scss']
})
export class WarningBarComponent {

    constructor() { }
}
